<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputTextArea
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../../QuestionBase";
import InputTextArea from "../../../../inputs/InputTextArea";

export default {
  name: 'ExistingWillChangesChildrenDetails',
  mixins: [questionLoadHelpers],
  components: {
    InputTextArea,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Please summarise what has changed in relation to your children or dependants:',
        subTitle:  null,
        tip: null
      },
      db: {
        saveLocation: 'estate_planning_survey_save',
        saveField: 'changes_dependants_details'
      },
      args: {
        placeholder: 'e.g. Had a son in 2015 called Alfie.',
        label: null,
        rows: 4,
        maxRows: 4,
        skippable: false,
        required: true,
        inputClass: 'field-100'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>